import { isPlatformBrowser } from '@angular/common';
import { Component, PLATFORM_ID, inject, signal, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-cde-toast-countdown',
  templateUrl: './cde-toast-countdown.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./cde-toast-countdown.component.scss'],
})
export class CdeToastCountdownComponent {
  readonly platformId = inject<number | string>(PLATFORM_ID);

  public timeLeft = signal(8);
  public interval: number;

  constructor() {
    if (isPlatformBrowser(this.platformId)) {
      this.interval = window.setInterval(() => {
        if (this.timeLeft() > 0) {
          this.timeLeft.update(timeLeft => timeLeft - 1);
        } else {
          clearInterval(this.interval);
        }
      }, 1000);
    }
  }
}
